import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import useNavigationTitle from "components/navigation/useNavigationTitle";
import { Menu } from "components/bootstrap";
import { Icon } from "components/common";
import { hoverIndicatorStyles } from "components/common/NavItemStateIndicator";
import usePermissions from "hooks/usePermissions";
import NavigationLink from "components/navigation/NavigationLink";
import shouldRenderNavigationItem from "components/navigation/util/shouldRenderNavigationItem";
import { NAV_ITEM_HEIGHT } from "theme/constants";
const BurgerToggle = styled.button(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    background: transparent;
    border: 0;
    padding: 0 15px;
    min-height: ${NAV_ITEM_HEIGHT};
    color: ${theme.colors.text.primary};

    &:hover,
    &:focus-visible {
      ${hoverIndicatorStyles(theme)}
    }
  `
);
const CollapsedMainNavbar = ({ navigationItems }) => {
  const { isPermitted } = usePermissions();
  const navigationTitle = useNavigationTitle();
  const { t } = useTranslation("navigation");
  const accessibleItems = navigationItems.filter(
    ({ requiredFeatureFlag, permissions }) => shouldRenderNavigationItem(requiredFeatureFlag, permissions, isPermitted)
  );
  return /* @__PURE__ */ React.createElement(Menu, null, /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(BurgerToggle, { type: "button", "aria-label": t("shell.toggle_navigation") }, /* @__PURE__ */ React.createElement(Icon, { name: "menu", size: "lg" }))), /* @__PURE__ */ React.createElement(Menu.Dropdown, null, accessibleItems.map(({ description, titleKey, path, children, BadgeComponent }) => {
    if (!children) {
      return /* @__PURE__ */ React.createElement(
        NavigationLink,
        {
          key: description,
          description: navigationTitle({ description, titleKey }),
          path,
          Badge: BadgeComponent
        }
      );
    }
    const accessibleChildren = children.filter(
      ({ requiredFeatureFlag, permissions, useCondition }) => {
        var _a;
        return (
          // eslint-disable-next-line react-hooks/rules-of-hooks
          ((_a = useCondition == null ? void 0 : useCondition()) != null ? _a : true) && shouldRenderNavigationItem(requiredFeatureFlag, permissions, isPermitted)
        );
      }
    );
    if (!accessibleChildren.length) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Menu.Sub, { key: description }, /* @__PURE__ */ React.createElement(Menu.Sub.Target, null, /* @__PURE__ */ React.createElement(Menu.Sub.Item, null, navigationTitle({ description, titleKey }))), /* @__PURE__ */ React.createElement(Menu.Sub.Dropdown, null, accessibleChildren.map((child) => /* @__PURE__ */ React.createElement(
      NavigationLink,
      {
        key: child.description,
        description: navigationTitle(child),
        path: child.path,
        Badge: child.BadgeComponent
      }
    ))));
  })));
};
export default CollapsedMainNavbar;
